import { api } from '@/api';
import { ActionContext } from 'vuex';
import { State } from '../state';
import { AppsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { commitSetMyApps } from './mutations';
import {
  dispatchCheckApiError,
  dispatchCheckExpiredSession,
} from '../main/actions';
import { AxiosError } from 'axios';

type MainContext = ActionContext<AppsState, State>;

export const actions = {
  async actionGetMyApps(context: MainContext) {
    try {
      const response = await api.getMyApps(context.rootState.main.token);
      await dispatchCheckExpiredSession(context, response);
      if (response) {
        commitSetMyApps(context, response.data);
      }
    } catch (error) {
      await dispatchCheckApiError(context, error as AxiosError);
    }
  },
};

const { dispatch } = getStoreAccessors<AppsState, State>('');

export const dispatchGetMyApps = dispatch(actions.actionGetMyApps);
